<script lang="ts">
    import { monster } from "../../../stores/monster";
    import Monster from "../../lib/monster";
    import MonsterPicture from '../Picture/index.svelte';
    import Details from './components/Details.svelte';
    import { phases } from './stores/game-phase';
    import { GamePhases } from "./types";

    let opponent = new Monster();
    let player = new Monster($monster);
</script>

<main>
    <h2 class='opponent-header'>Opponent</h2>
    <div class='opponent'>
        <MonsterPicture monster={opponent}/>
    </div>
    <div class='opponent-details'>
        <Details
            monster={opponent}
            onSetMoves={() => phases.update(prev => ({
                ...prev,
                opponent: GamePhases.SelectMove
            }))}
        />
    </div>
    <h2 class='player-header'>You</h2>
    <div class='player'>
        <MonsterPicture monster={player}/>
    </div>
    <div class='player-details'>
        <Details
            monster={player}
            onSetMoves={() => phases.update(prev => ({
                ...prev,
                player: GamePhases.SelectMove
            }))}
        />
    </div>
</main>

<style>
main {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-areas: ". opponent-header"
                         "opponent-details opponent-monster"
                         "player-header ."
                         "player-monster player-details";
    grid-template-rows: max-content 1fr max-content 1fr;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}

.opponent-header {
    grid-area: opponent-header;
}

.opponent {
    grid-area: opponent-monster;
}

.opponent-details {
    grid-area: opponent-details;
}

.player-header {
    grid-area: player-header;
}

.player {
    grid-area: player-monster;
}

.player-details {
    grid-area: player-details;
}

@media only screen and (max-width: 600px) {
    main {
        grid-template-areas: "opponent-details opponent-monster"
                             "player-monster player-details";
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
        padding: 10px;
        box-sizing: border-box;
    }

    .player-details, .opponent-details {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    h2 {
        display: none;
    }
}
</style>
